// A document line prints its service name and, under it, only the note the rep wrote. The
// master-data description of a service is never printed: old lines still carry it as their
// `description` (and some baked it into `subDescription`), so it is dropped here.

interface LineLike {
  name?: string | null
  description?: string | null
  notes?: string | null
  subDescription?: string | null
}

/** The text printed under a line's name (empty when there is none). */
export function printedLineNote(item: LineLike | null | undefined): string {
  if (!item) return ''
  const name = String(item.name ?? '').trim()
  const description = String(item.description ?? '').trim()
  const notes = String(item.notes ?? '').trim()
  let sub = String(item.subDescription ?? '').trim()
  if (!sub) return notes
  // The master description was written first, ahead of the note and any "milestone share" suffix.
  if (description && description !== name && sub.startsWith(description)) {
    sub = sub.slice(description.length).replace(/^[\s·•-]+/, '').trim()
  }
  return sub
}
